import { cn } from '@anytag/shared-utils';
import { Input as AnyuiInput, type InputProps as AnyuiInputProps } from '@anyui/core';

export type InputProps = React.ComponentPropsWithRef<'input'> & Omit<AnyuiInputProps, 'component'>;

export const Input = ({ classNames, ...restProps }: InputProps) => (
  // @ts-expect-error Expression produces a union type that is too complex to represent.ts(2590)
  <AnyuiInput
    size="md"
    classNames={{
      ...classNames,
      inputGroup: cn(
        {
          '[--input-left-section-width:--spacing(8)]': !!restProps.leftSection,
          '[--input-right-section-width:--spacing(8)]': !!restProps.rightSection
        },
        classNames?.inputGroup
      )
    }}
    {...restProps}
  />
);
